<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addGoodsSeries">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-row :gutter="20">
        <a-col
          :span="4"
          v-for="item in table.data"
          :key="item.id">
          <a-card
            style="margin-bottom: 20px"
            hoverable
            v-if="item.id!='1531903218005708800'">
           <img
             slot="cover"
             alt="example"
             class="cover-img"
             :src="item.coverPath"
           />
            <template slot="actions" class="ant-card-actions">
              <a-icon type="edit" @click="editGoodsSeries(item.id)"/>
              <a-icon type="eye"  @click="detailGoodsSeries(item.id)"/>
              <a-icon type="left"  @click="upGoodsSeries(item.id)"/>
              <a-icon type="right"  @click="downGoodsSeries(item.id)"/>
              <a-icon type="close" @click="deleteGoodsSeries(item.id)">
              </a-icon>
            </template>
            <a-card-meta :title="item.name" :description="item.nameEn">

            </a-card-meta>
          </a-card>
        </a-col>
      </a-row>
    </div>
    <a-modal
      :footer="null"
        title="编辑"
        v-model="form.visible">
      <goodsSeries-edit
        v-if="form.visible"
        :goods-series-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </goodsSeries-edit>
    </a-modal>
    <a-drawer
    title="系列商品"
      placement="right"
      :closable="false"
      width="60%"
      :destroyOnClose="true"
      @close="()=>{goodsForm.visible = false}"
      :visible="goodsForm.visible"
    >
      <goods-series-items
        v-if="goodsForm.visible"
        :series-id="goodsForm.data.id">
      </goods-series-items>
    </a-drawer>
  </a-card>
</template>

<script>
import {
  _queryGoodsSeriess,
  _deleteGoodsSeries,
  _upGoodsSeries,
  _downGoodsSeries,
} from '@/api/goodsSeriesApi';
import GoodsSeriesEdit from './GoodsSeriesEdit.vue';
import GoodsSeriesItems from './GoodsSeriesItems.vue';

async function getGoodsSeriesList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryGoodsSeriess({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  const list = result.content.filter(item => item.id !== '1531903218005708800');
  this.table.data = list;
}

function addGoodsSeries() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editGoodsSeries(goodsSeriesId) {
  this.form.data.id = goodsSeriesId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getGoodsSeriesList();
}

async function deleteGoodsSeries(goodsSeriesId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteGoodsSeries(goodsSeriesId);
      this.$message.success('删除成功');
      this.getGoodsSeriesList();
    },
  });
}

function detailGoodsSeries(goodsSeriesId) {
  this.goodsForm.data.id = goodsSeriesId;
  this.goodsForm.visible = true;
}

async function upGoodsSeries(goodsSeriesId) {
  this.$confirm({
    title: '是否上移？',
    content: '',
    onOk: async () => {
      await _upGoodsSeries(goodsSeriesId);
      this.$message.success('上移成功');
      this.getGoodsSeriesList();
    },
  });
}

async function downGoodsSeries(goodsSeriesId) {
  this.$confirm({
    title: '是否下移？',
    content: '',
    onOk: async () => {
      await _downGoodsSeries(goodsSeriesId);
      this.$message.success('下移成功');
      this.getGoodsSeriesList();
    },
  });
}

export default {
  name: 'GoodsSeriesList',
  components: {
    GoodsSeriesEdit,
    GoodsSeriesItems,
  },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      goodsForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getGoodsSeriesList,
    deleteGoodsSeries,
    editGoodsSeries,
    addGoodsSeries,
    closeForm,
    detailGoodsSeries,
    upGoodsSeries,
    downGoodsSeries
  },
  created() {
    this.getGoodsSeriesList();
  },
};
</script>

<style scoped>

</style>
